import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#6058C8',
        secondary: '#4A5568',
        accent: '#9F98E8',
        error: '#FF5252',
        info: '#9F98E8',
        success: '#558B6E',
        warning: '#E8B931'
      },
      dark: {
        primary: '#6058C8',
        secondary: '#A0AEC0',
        accent: '#9F98E8',
        error: '#FF5252',
        info: '#9F98E8',
        success: '#81C784',
        warning: '#FFD54F'
      }
    }
  }
});
